import React, { useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { commonservices } from "../services/CommonServices";
import infoIcon from "../assets/images/infobtnblue.svg";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const MachineRejectModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    commentBox: "",
    errors: {
      commentBox: "",
      ValidationRules: [
        {
          FieldName: "commentBox",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="reject-comment-modal"
      backdrop="static"
    >
      {loading && <MainpageLoader/>}
      <Modal.Header closeButton>Comment</Modal.Header>
      <Modal.Body>
        <Form.Group className="form-group mb16">
          <Form.Label className="common-label">Write a Comment<span className="ms-1 red-color-text">*</span></Form.Label>
          <div className="position-relative">
            <Form.Control
              as="textarea"
              type="text"
              placeholder="Comment"
              value={input?.commentBox}
              className="common-input h-auto"
              onChange={(e) => {
                setInput({
                  ...input,
                  commentBox: e.target.value,
                });
              }}
              rows={5}
              isInvalid={input.errors.commentBox}
            />
            {input.errors.commentBox && (
              <Form.Control.Feedback type="invalid">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.commentBox}
                  />
                </span>
              </Form.Control.Feedback>
            )}
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={props.onHide}>
          Close
        </button>
        <button
          className="blue-btn w-auto"
          onClick={(e) => {
            let validation = commonservices.fnCheckValidationOfObject(input);
            if (validation?.isValid) {
              setLoading(true);
              props?.updateMachineStatus("Rejected", input?.commentBox);
            } else {
              setInput({ ...validation?.obj });
            }
          }}
        >
          {loading ? (
            // <>
            //   <span>Loading</span>{" "}
            //   <Spinner
            //     className="ms-1"
            //     animation="border"
            //     role="status"
            //     size="sm"
            //   >
            //     <span className="visually-hidden">Loading...</span>
            //   </Spinner>
            // </>
            <SubmitLoading />
          ) : (
            "Submit"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MachineRejectModal;
